import React, {Component} from 'react';

class Contact extends Component {
  render() {
    return (
      <section id="contact">
        <div className="row">
          <div className="eight columns">
            <h4>About Me</h4>

            <p>
              I am a web system developer with more than 7 years experience, especially in building and maintaining web application, both on application side and system side.
              Interested in wide scale information system. Experienced in workplace environment, high pressure condition, and culture adaptation through some work and organizational experiences. Capable work independently or in team with just a little supervision.
              Friendly and fairly introvert guy who enjoys reading, watching, and travelling. Love to learn, discover new things, and always try to be better every time.
            </p>
          </div>

          <aside className="four columns footer-widgets">
            <div className="widget widget_contact">

              <h4>Address and Phone</h4>
              <p className="address">
                <span>Muhammad Yusuf Maulana</span><br/>
                <span>Indonesia</span><br/>
                <span>+62 812 2057 5075</span><br/>
                <span>mail@yusuf-maulana.com</span>
              </p>
            </div>

            <div className="columns download">
              <p>
                <a href="https://www.dropbox.com/s/afx0vs57a2nm6zc/cv-yusuf.pdf?dl=0" className="button">
                  <i className="fa fa-download"></i>Download CV
                </a>
              </p>
            </div>
          </aside>
        </div>
      </section>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/Components/Contact.js